import { RECEIVABLE_LIST_REQUESTED, RECEIVABLE_LIST_LOADED, API_ERRORED } from "../constants/action-types";

export function getReceivableList() {
    return { type: RECEIVABLE_LIST_REQUESTED }
};

export function receivableListLoaded(payload) {
    return { type: RECEIVABLE_LIST_LOADED, payload }
};

export function apiError(payload) {
	//TODO: check the payload for detail message ... maybe log it
    return { type: API_ERRORED, payload : {id: 1, message: 'API error!'} }
};
